import React from 'react';

/**
 * Bandeau de suggestion non bloquante (ex. "bascule eau de ville recommandée") — informe et
 * pré-coche par défaut, mais ne verrouille jamais l'option correspondante.
 */
const RecommendationBanner = ({ children }) => (
  <div className="apv2-step-explanation rw-recommendation-banner">
    <span className="apv2-step-explanation-icon">💡</span>
    <p className="apv2-step-explanation-text">{children}</p>
  </div>
);

export default RecommendationBanner;
